import React from 'react';
import laptopCampaign from '../img/png/laptop_campaign.png';

function HowItWorks() {
  return (
    <>
      <section className='works d-flex justify-content-center align-items-center'>
        <div className='works_container d-flex-row gap-3 align-items-center justify-content-between'>
          <div className='works_container_left'>
            <img src={laptopCampaign} alt='background' />
          </div>
          <div className='works_container_right d-flex-col gap-1'>
            <div className='line'></div>
            <h2 className='text-title'>How It Works</h2>
            <p className='text-gray'>
              From data collection, all the way to ad-placement we have the
              world’s largest taxonomy of audiences which, coupled with supply,
              are activated through our global ad-server network.
            </p>
            <p className='text-gray'>
              Our technology focuses on groups and their behaviours, not
              individuals. Each impression is targeted and placed at a
              single-page, full URL level. The media-buying workflow is fully
              automated and managed by the AI.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default HowItWorks;
